// extracted by mini-css-extract-plugin
module.exports = {"systemMsg":"style_systemMsg__3p7s_","msg":"style_msg__28Krt","close_btn":"style_close_btn__3hnre"};